import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Loading from '../../../components/common/Loading';
import Tabs from '../../../components/common/Tabs';
import VacancyForm from '../../../components/module/rec/vacancy/VacancyForm';
import VacancyJDForm from '../../../components/module/rec/vacancy/VacancyJDForm';
import VacancyUploadForm from '../../../components/module/rec/vacancy/VacancyUploadForm';
import api from '../../../utils/api';
import EditIcon from '../../../components/common/icons/EditIcon';
import { useNavigate, useParams } from 'react-router-dom';

const AddVacancy: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<any>();

  useEffect(() => {
    const fetchTabs = async () => {
      try {
        setIsLoading(true);
        const response = await api<{ data: any[] }>({
          method: 'GET',
          url: `/cmn/menu/tab/${10}`,
        });
        setActiveTab(response.data.data[0].menuId);
        setTabs((response.data.data ?? []).map((tab) => ({ label: tab.name, value: tab.menuId })));
      } catch (error) {
        console.error('Error fetching tabs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTabs();
  }, []);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  const renderContent = () => {
    switch (activeTab) {
      case tabs[0]?.value:
        return <VacancyForm type="view" onCancel={() => { }} onSave={() => { }} />;
      case tabs[1]?.value:
        return <VacancyJDForm type="view" onCancel={() => { }} onSave={() => { }} />;
      case tabs[2]?.value:
        return <VacancyUploadForm type="view" onCancel={() => { }} onSave={() => { }} />;
      default:
        return null;
    }
  };

  return (
    <Box className="page-container" p={3}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className="page-title" mb={3}>
              View Vacancy
            </Typography>
            <IconButton onClick={() => {
              navigate(`/rec/vacancy/search/${params.id}/edit`);
            }}>
              <EditIcon size={24} />
            </IconButton>
          </Box>
          <Box mb={3}>
            <Tabs
              tabs={tabs}
              value={activeTab}
              onChange={handleTabChange}
            />
          </Box>
          {renderContent()}
        </>
      )}
    </Box>
  );
};

export default AddVacancy; 